import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { SessionSliceType, refreshTokenUpdateProps } from './types';

const initialState: SessionSliceType = {
  agentId: null,
  entitlements: {},
  features: [],
  token: null,
  accessToken: '',
  refreshToken: '',
  userLoggedIn: false,
  missingPii: [],
  userOffline: false,
};

const sessionSlice = createAppSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionSlice(state, action: PayloadAction<SessionSliceType>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    refreshTokenUpdate(state, action: PayloadAction<refreshTokenUpdateProps>) {
      const { accessToken, refreshToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
    },
    setMissingPii(state, action: PayloadAction<string[]>) {
      state.missingPii = action.payload;
    },
    userSignOut() {
      return initialState;
    },
  },
});

export const {
  setSessionSlice,
  userSignOut,
  refreshTokenUpdate,
  setMissingPii,
} = sessionSlice.actions;
export default sessionSlice.reducer;
